import React from 'react';
import { constantToLabel } from '@ecosconnect/core/src/helpers/string';
import StatusDot, { StatusStyle } from '../Status/StatusDot';
import { Column } from '../../hooks/useTablePages';
import { ServiceAddress } from './types';

const columns: Column[] = [
  {
    header: 'Status',
    id: 'status',
    accessor: (row: ServiceAddress) => {
      let style: StatusStyle = 'default';

      if (row.active && row.waterService?.status !== 'INACTIVE') {
        style = 'success';
      } else {
        style = 'error';
      }

      return <StatusDot status={style} mr="1" />;
    },
    stringAccessor: (row: any): string => {
      return constantToLabel(row.waterService.status);
    },
    width: 66,
  },
  {
    header: 'Service',
    accessor: 'waterService.siteNumber',
    width: 96,
  },
  {
    header: 'Address',
    id: 'address.id',
    accessor: (row) =>
      row.address
        ? row.address.street1 +
          (row.address.street2 ? ', ' + row.address.street2 : '')
        : '',
    width: 152,
  },
];

export const companyServiceAddressColumns: Column[] = columns.filter(
  (column) => column.header !== 'Service'
);

export default columns;
